module.exports = __webpack_public_path__ + "static/media/butt02.34c0a648.png";